import ReactApexChart from "react-apexcharts";
import { FaChartLine } from "react-icons/fa6";

import { DealerDashboardData } from "@Hooks/useDealersDashboard";
import { formatPrice } from "@Utils/functions";

import styles from "./Dealer.module.scss";

const DealerPerformanceChart = ({
  data,
}: {
  data: DealerDashboardData | undefined,
}) => {
  const series = [
    {
      name: "Amount financed",
      data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map(
        (month) =>
          data?.data?.amountFinancedByMonth?.find(
            (stat) => stat.month === month
          )?.totalAmountFinanced || 0
      ),
    },
  ];
  const options: ApexCharts.ApexOptions = {
    chart: {
      height: 350,
      type: "bar",
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val: number) {
        return formatPrice(val) || "";
      },
      offsetY: -15,
      style: {
        fontSize: "10px",
        colors: ["#304758"],
      },
    },

    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      position: "top",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },

      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val: number) {
          return formatPrice(val) || "";
        },
      },
    },
  };
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionTitle}>
        Performance
        <FaChartLine size={25} />
      </div>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div className={styles.sectionContent}>
            <div className={styles.sectionContentTitle}>Look to book</div>
            <div className={styles.sectionContentValue}>
              {parseInt(data?.data?.lookToBook?.toString() || "0")} %
            </div>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.sectionContentTitle}>
              Total amount financed requested
            </div>
            <div className={styles.sectionContentValue}>
              {formatPrice(data?.data?.totalAmountRequested || 0)}
            </div>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.sectionContentTitle}>Total applications</div>
            <div className={styles.sectionContentValue}>
              {parseInt((data?.data?.totalApplications || 0).toString())}
            </div>
          </div>
        </div>
        <div
          className={styles.sectionContent}
          style={{
            flex: 1,
            height: 240,
            background: "white",
            padding: 0,
            paddingTop: 10,
          }}
        >
          <div
            style={{
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            Funded amount financed by month ({new Date().getFullYear()})
          </div>

          <ReactApexChart
            options={options}
            series={series}
            type="bar"
            height={240}
          />
        </div>
      </div>
    </div>
  );
};

export default DealerPerformanceChart;
